import {EcommerceSettingsService} from '@wix/wixstores-client-storefront-sdk';
import {PaymentRequestSettingsModel} from '../../models/paymentRequest/PaymentRequestSettings.model';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';

export class PaymentRequestSettingsService {
  public paymentRequestSettings!: PaymentRequestSettingsModel;
  private readonly eCommerceSettingsService?: EcommerceSettingsService;
  private readonly viewerContext: ViewerContext;

  constructor({
    eCommerceSettingsService,
    viewerContext,
  }: {
    eCommerceSettingsService?: EcommerceSettingsService;
    viewerContext: ViewerContext;
  }) {
    this.eCommerceSettingsService = eCommerceSettingsService;
    this.viewerContext = viewerContext;
  }

  public async fetchSiteSettings(): Promise<void> {
    const ecommerceSettings = await this.eCommerceSettingsService?.getEcommerceSettings();
    this.paymentRequestSettings = new PaymentRequestSettingsModel({
      ecommerceSettings,
    });
  }

  public async init(): Promise<void> {
    await this.fetchSiteSettings();
  }
}
